"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeInvalidCompanyNameChars = void 0;
const regex_1 = require("./validators/regex");
/**
 * Removes invalid characters which are not allowed by the isAllowedCompanyNameCharsOnly regex
 */
const removeInvalidCompanyNameChars = (text) => {
    if (!text) {
        return text;
    }
    return text.replace(regex_1.invalidCompanyNameCharRegex, "");
};
exports.removeInvalidCompanyNameChars = removeInvalidCompanyNameChars;
